"use client";

import { useState } from "react";
import { LogOut } from "lucide-react";

import { clearOfflineSnapshot } from "@/lib/offline-snapshot";

function clearDeviceData(): void {
  clearOfflineSnapshot(window.localStorage);
  try {
    const channel = new BroadcastChannel("horosho-session");
    channel.postMessage({ type: "LOGOUT" });
    channel.close();
  } catch {
    // The storage event still clears other tabs when BroadcastChannel is unavailable.
  }
}

export function LogoutButton() {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");

  const logout = async () => {
    setPending(true);
    setError("");
    clearDeviceData();
    try {
      const response = await fetch("/api/auth/logout", {
        method: "POST",
        credentials: "same-origin",
        cache: "no-store"
      });
      if (!response.ok) throw new Error("Logout request failed");
      window.location.assign("/login");
    } catch {
      setError("Device data cleared. Reconnect to finish signing out.");
      setPending(false);
    } finally {
      clearDeviceData();
    }
  };

  return (
    <div className="relative">
      <button
        type="button"
        aria-label="Log out"
        title="Log out"
        disabled={pending}
        onClick={logout}
        className="grid size-11 cursor-pointer place-items-center rounded-md border border-[var(--hc-border)] text-[var(--hc-muted)] transition-colors hover:bg-[var(--hc-surface-2)] hover:text-[var(--hc-text)] disabled:cursor-wait disabled:opacity-50"
      >
        <LogOut size={17} aria-hidden="true" />
      </button>
      {error ? (
        <p role="alert" className="absolute right-0 top-12 z-40 w-64 rounded-md border border-[var(--hc-border-strong)] bg-[var(--hc-surface-2)] p-3 text-xs leading-5 text-[var(--hc-warning)] shadow-xl">
          {error}
        </p>
      ) : null}
    </div>
  );
}
